var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { has, isArray, mapValues } from '@ally/utilitarian';
export function serialize(data) {
    return __assign(__assign({}, data), { body: data.body && JSON.stringify(data.body) });
}
export function isObject(x) {
    return !!x && typeof x === 'object';
}
export function isTypeValuePair(x) {
    return has(x, 'type') && has(x, 'value');
}
export function deepMap(object, fn) {
    function iteratee(x, k) {
        if (!isObject(x))
            return fn(x, k);
        if (isTypeValuePair(x)) {
            // When a Type Value Pair object is detected run the type/value through
            // the given function AND also run for every other property
            var type = x.type, value = x.value, rest = __rest(x, ["type", "value"]);
            return __assign(__assign({}, mapValues(rest, iteratee)), { type: type, value: fn(value, type) });
        }
        // If array, check if the name of the array is in list of
        // properties to mask. If not masked, then individual entries
        // in the array should be looked at for masking
        if (isArray(x)) {
            var mappedResult = fn(x, k);
            return mappedResult === '*' ? mappedResult : x.map(function (v) { return iteratee(v, null); });
        }
        return mapValues(x, iteratee);
    }
    return iteratee(object, '');
}
export function attempt(f) {
    try {
        return f();
    }
    catch (e) {
        return null;
    }
}
//# sourceMappingURL=lib.js.map